module.exports = __webpack_public_path__ + "img/katoriki.522fcebb.jpg";